import http, { encode } from './index';

export const startTrialVersion = async (company, site) =>
  http.post(`/companies/${encode(company)}/sites/${encode(site)}/services/MOBILE_VIDEO/licence`, {
    action: 'ACTIVATE_TRIAL',
  });